module.exports = __webpack_public_path__ + "img/shirt.71fd0b61.png";